import { render, staticRenderFns } from "./SamLoader.vue?vue&type=template&id=061b6f53&scoped=true&shadow"
import script from "./SamLoader.vue?vue&type=script&lang=js&shadow"
export * from "./SamLoader.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamLoader.vue?vue&type=style&index=0&id=061b6f53&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "061b6f53",
  null
  ,true
)

export default component.exports